/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri May 17 2024
 **/

import ReactQuill from "@rsupport/react-quill";

class CustomQuillMention {
	private _quill: ReactQuill | null;
	constructor(quill: ReactQuill | null) {
		this._quill = quill;
	}

	getMentionList() {
		return document.querySelectorAll(".mention-list-item");
	}
	getFocusedMentionItem() {
		let currentFocusItem: Element | undefined = undefined;
		let currentFocusItemIndex = 0;
		this.getMentionList().forEach((element, index) => {
			if (element.classList.contains("selected")) {
				currentFocusItemIndex = index;
				currentFocusItem = element;
			}
		});

		if (!currentFocusItem) return null;

		return { item: currentFocusItem as Element, index: currentFocusItemIndex };
	}
	highlightItem(index: number, behavior: "smooth" | "instant" = "smooth") {
		const mentionList = this.getMentionList();
		mentionList[index].classList.add("selected");
		this._quill?.editor?.root.setAttribute("aria-activedescendant", mentionList[index].id);
		mentionList[index].scrollIntoView({
			behavior,
			block: "nearest"
		});
	}
	highlightNext() {
		const currentFocusItem = this.getFocusedMentionItem();
		if (currentFocusItem) {
			const { index, item } = currentFocusItem;
			const mentionList = this.getMentionList();
			let newIndex = index;
			if (index === mentionList.length - 1) {
				newIndex = 0;
			} else {
				newIndex = index + 1;
			}
			item.classList.remove("selected");
			if (index === mentionList.length - 1) {
				this.highlightItem(newIndex, "instant");
			} else {
				this.highlightItem(newIndex, "instant");
			}
		}
	}
	highlightPrev() {
		const currentFocusItem = this.getFocusedMentionItem();
		if (currentFocusItem) {
			const { index, item } = currentFocusItem;
			const mentionList = this.getMentionList();
			let newIndex = index;
			if (index === 0) {
				newIndex = mentionList.length - 1;
			} else {
				newIndex = index - 1;
			}
			item.classList.remove("selected");
			if (index === 0) {
				this.highlightItem(newIndex, "instant");
			} else {
				this.highlightItem(newIndex, "instant");
			}
		}
	}
	selectMention(item: Element) {
		const denotationChar = item.getAttribute("data-denotationChar");
		const id = item.getAttribute("data-id");
		const index = item.getAttribute("data-index");
		const value = item.getAttribute("data-value");
		return { denotationChar, id, index, value };
	}
}

export default CustomQuillMention;
